module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n/**\n * This block destructures the local variables for use within this ejs template.\n */\nvar options = locals.options;\n%>\n<% var msg = require(\'@cdo/locale\'); %>\n<% if (options.feedbackImage) { %>\n  <img class="feedback-image" src="<%= options.feedbackImage %>"/>\n  <div class="sharing-content">\n<% } else { %>\n  <div class="sharing-content no-image">\n<% } %>\n\n<% if (options.shareLink) { %>\n  <% if (options.appStrings && options.appStrings.sharingText) { %>\n    <div><%= options.appStrings.sharingText %></div>\n  <% } %>\n\n  <div id="sharing-input-container">\n    <button id="sharing-dialog-copy-button" value=<%= options.shareLink %>>\n      <i class="fa fa-clipboard fa-lg"></i>\n        <%= msg.copyLinkToProject() %>\n    </button>\n    <% if (options.downloadReplayVideo) { %>\n      \x3c!-- Mount point for DownloadReplayVideoButton component. --\x3e\n      <span id="download-replay-video-container"></span>\n    <% } %>\n  </div>\n  <div class=\'social-buttons\'>\n    <% if (options.facebookUrl) { -%>\n      <a id=\'sharing-facebook\' href=\'<%= options.facebookUrl %>\' target="_blank" class="popup-window" style="display: none">\n        <button id=\'facebook-button\'>\n          <i class="fa fa-facebook fa-lg"></i>\n        </button>\n      </a>\n    <% } -%>\n    <% if (options.twitterUrl) { -%>\n      <a id=\'sharing-twitter\' href=\'<%= options.twitterUrl %>\' target="_blank" class="popup-window" style="display: none">\n        <button id=\'twitter-button\'>\n          <i class="fa fa-twitter fa-lg"></i>\n        </button>\n      </a>\n    <% } -%>\n    <% if (!options.onMainPage && options.enablePrinting) { %>\n      <button id="print-button">\n        <i class="fa fa-print fa-lg"></i>\n      </button>\n    <% } %>\n    <% if (options.alreadySaved) { %>\n      <button class="saved-to-gallery" disabled>\n        <%= msg.savedToGallery() %>\n      </button>\n    <% } else if (options.saveToProjectGallery && !options.disableSaveToGallery) { %>\n      <button id="save-to-project-gallery-button">\n        <%= msg.addToProjects() %>\n      </button>\n    <% } %>\n   <button id="sharing-phone">\n      <i class="fa fa-mobile fa-lg"></i>\n      &nbsp;\n      <%= msg.sendToPhone() %>\n    </button>\n    <div id="download-replay-video-error" style="font-size: 12px; display: none;">\n      <%= msg.downloadReplayVideoButtonError() %>\n    </div>\n  </div>\n\n<% } %>\n\n</div>\n\n<% /* Always show the "Send to phone" button, and when it\'s clicked to toggle\n    * the section below into view, the QR Code, but only show the phone number\n    * in that section below when options.isUS is true, which is done\n    * for US users. */ %>\n<div id="send-to-phone" style="display: none">\n  <% if (options.isUS) { %>\n    <div id="send-to-phone-left">\n      <label for="phone">Enter a US phone number:</label>\n      <input type="tel" id="phone" name="phone" />\n      <button id="phone-submit" onClick="return false;">Send</button>\n      <div id="phone-charges">A text message will be sent via <a href="http://twilio.com" target="_blank">Twilio</a>. Charges may apply to the recipient.</div>\n    </div>\n  <% } %>\n  <div id="send-to-phone-right">\n    <label><%= msg.scanQRCode() %></label>\n    <div id="send-to-phone-qr-code"></div>\n  </div>\n</div>\n', __filename = "src/templates/sharing.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var options = locals.options;
        __line = 6;
        __append("\n");
        __line = 7;
        var msg = require("@cdo/locale");
        __append("\n");
        __line = 8;
        if (options.feedbackImage) {
            __append('\n  <img class="feedback-image" src="');
            __line = 9;
            __append(escapeFn(options.feedbackImage));
            __append('"/>\n  <div class="sharing-content">\n');
            __line = 11;
        } else {
            __append('\n  <div class="sharing-content no-image">\n');
            __line = 13;
        }
        __append("\n\n");
        __line = 15;
        if (options.shareLink) {
            __append("\n  ");
            __line = 16;
            if (options.appStrings && options.appStrings.sharingText) {
                __append("\n    <div>");
                __line = 17;
                __append(escapeFn(options.appStrings.sharingText));
                __append("</div>\n  ");
                __line = 18;
            }
            __append('\n\n  <div id="sharing-input-container">\n    <button id="sharing-dialog-copy-button" value=');
            __line = 21;
            __append(escapeFn(options.shareLink));
            __append('>\n      <i class="fa fa-clipboard fa-lg"></i>\n        ');
            __line = 23;
            __append(escapeFn(msg.copyLinkToProject()));
            __append("\n    </button>\n    ");
            __line = 25;
            if (options.downloadReplayVideo) {
                __append('\n      \x3c!-- Mount point for DownloadReplayVideoButton component. --\x3e\n      <span id="download-replay-video-container"></span>\n    ');
                __line = 28;
            }
            __append("\n  </div>\n  <div class='social-buttons'>\n    ");
            __line = 31;
            if (options.facebookUrl) {
                __append("      <a id='sharing-facebook' href='");
                __line = 32;
                __append(escapeFn(options.facebookUrl));
                __append('\' target="_blank" class="popup-window" style="display: none">\n        <button id=\'facebook-button\'>\n          <i class="fa fa-facebook fa-lg"></i>\n        </button>\n      </a>\n    ');
                __line = 37;
            }
            __append("    ");
            __line = 38;
            if (options.twitterUrl) {
                __append("      <a id='sharing-twitter' href='");
                __line = 39;
                __append(escapeFn(options.twitterUrl));
                __append('\' target="_blank" class="popup-window" style="display: none">\n        <button id=\'twitter-button\'>\n          <i class="fa fa-twitter fa-lg"></i>\n        </button>\n      </a>\n    ');
                __line = 44;
            }
            __append("    ");
            __line = 45;
            if (!options.onMainPage && options.enablePrinting) {
                __append('\n      <button id="print-button">\n        <i class="fa fa-print fa-lg"></i>\n      </button>\n    ');
                __line = 49;
            }
            __append("\n    ");
            __line = 50;
            if (options.alreadySaved) {
                __append('\n      <button class="saved-to-gallery" disabled>\n        ');
                __line = 52;
                __append(escapeFn(msg.savedToGallery()));
                __append("\n      </button>\n    ");
                __line = 54;
            } else if (options.saveToProjectGallery && !options.disableSaveToGallery) {
                __append('\n      <button id="save-to-project-gallery-button">\n        ');
                __line = 56;
                __append(escapeFn(msg.addToProjects()));
                __append("\n      </button>\n    ");
                __line = 58;
            }
            __append('\n   <button id="sharing-phone">\n      <i class="fa fa-mobile fa-lg"></i>\n      &nbsp;\n      ');
            __line = 62;
            __append(escapeFn(msg.sendToPhone()));
            __append('\n    </button>\n    <div id="download-replay-video-error" style="font-size: 12px; display: none;">\n      ');
            __line = 65;
            __append(escapeFn(msg.downloadReplayVideoButtonError()));
            __append("\n    </div>\n  </div>\n\n");
            __line = 69;
        }
        __append("\n\n</div>\n\n");
        __line = 73;
        __line = 76;
        __append('\n<div id="send-to-phone" style="display: none">\n  ');
        __line = 78;
        if (options.isUS) {
            __append('\n    <div id="send-to-phone-left">\n      <label for="phone">Enter a US phone number:</label>\n      <input type="tel" id="phone" name="phone" />\n      <button id="phone-submit" onClick="return false;">Send</button>\n      <div id="phone-charges">A text message will be sent via <a href="http://twilio.com" target="_blank">Twilio</a>. Charges may apply to the recipient.</div>\n    </div>\n  ');
            __line = 85;
        }
        __append('\n  <div id="send-to-phone-right">\n    <label>');
        __line = 87;
        __append(escapeFn(msg.scanQRCode()));
        __append('</label>\n    <div id="send-to-phone-qr-code"></div>\n  </div>\n</div>\n');
        __line = 91;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}